import { useEffect, useRef, useState } from 'react'
import { useStatusOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@fs/zion-analytics'

const SESSION_KEY = 'tree_attachment_prompt_shown'

export default function useTreeAttachmentPrompts({ openAttachToTree }) {
  const showStatusOverlay = useStatusOverlay()
  const { t } = useTranslation()
  const timer = useRef(null)
  const [hasShownInSession, setHasShownInSession] = useState(() => {
    return sessionStorage.getItem(SESSION_KEY) === 'true'
  })

  const showAttachmentPrompt = () => {
    if (hasShownInSession) return

    // Mark as shown in session
    sessionStorage.setItem(SESSION_KEY, 'true')
    setHasShownInSession(true)

    showStatusOverlay({
      message: t('tree-attachment.prompt', 'Would you like to attach this image to your tree?'),
      type: 'normal',
      dismissable: true,
      actionLabel: t('tree-attachment.attach', 'Attach'),
      actionCallback: () => {
        trackEvent({
          event_name: 'click_action',
          link_name: 'attach-to-tree-from-prompt',
        })
        openAttachToTree()
      },
    })
  }

  const startViewTimer = () => {
    // Clear any existing timer
    if (timer.current) {
      clearTimeout(timer.current)
    }

    // Set new timer for 60 seconds
    timer.current = setTimeout(() => {
      showAttachmentPrompt()
    }, 60000) // 60 seconds
  }

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (timer.current) {
        clearTimeout(timer.current)
      }
    }
  }, [])

  return {
    startViewTimer,
    hasShownInSession,
  }
}
